import { ReduxState } from "../store";

export const selectUserId = (state: ReduxState) => state.auth.userId;
export const selectIsLoggedIn = (state: ReduxState) => state.auth.isLoggedIn;
export const selectSigningOut = (state: ReduxState) => state.auth.signingOut;
export const selectFetchStatus = (state: ReduxState) => state.auth.fetchStatus;
export const selectLogOutModal = (state: ReduxState) => state.auth.signOutModal;
export const selectAccessToProtectedRoutes = (state: ReduxState) => state.auth.accessToProtectedRoutes;
